<template>
  <div
    class="rb-load-more"
    ref="elLoadMore"
    style="background-color: #fff; width: 30px; height: 30px"
  ></div>
</template>
<script>
/**
 * Widget that fires load more events for infinite scroll
 *
 * @implements
 * CommMixin
 *
 * @emits
 * rb-load-next-page
 */
import CommMixin from "@/mixins/CommMixin";
export default {
  mixins: [CommMixin],
  data: function () {
    return {
      loadMoreObserver: null,
    };
  },
  mounted: function () {
    this.initObserver();
  },
  methods: {
    initObserver: function () {
      this.loadMoreObserver = new IntersectionObserver(
        (event) => {
          if (event.length && event[0].isIntersecting) {
            this.broadcast("rb-load-next-page");
          }
        },
        {
          rootMargin: "0px",
          threshold: 0.1,
        }
      );
      this.loadMoreObserver.observe(this.$refs.elLoadMore);
    },
  },
};
</script>
